import * as THREE from 'three';
export default THREE;